import React from 'react';
import Main from './components/Main';
import { PluginHarness } from '@missionlabs/smartagent-app-components';
import { AppProvider } from './AppContext';

const devContact = {
    customerEndpointAddress: '447506113682'
};

const App: React.FC = () => {
    const isEmbedded = window.parent !== window;

    return (
        <AppProvider>
            {isEmbedded ? (
                <Main />
            ) : (
                <PluginHarness contact={devContact}>
                    <Main />
                </PluginHarness>
            )}
        </AppProvider>
    );
};

export default App;
